import { type CustomFieldValueFilterBase } from '~/components/Filters/CustomFieldFilter/utils';
import { FilterLogicSelect } from '~/components/Filters/FilterLogicSelect';
import { type FilterLogicType } from '~/store/filters/types';
import { CustomFieldValuesFilterSelect } from './CustomFieldValuesFilterSelect';

export type CustomFieldFilterProps = {
  values: CustomFieldValueFilterBase[];
  selectedLogic: FilterLogicType;
  onLogicChange: (logic: FilterLogicType) => void;
  selectedValues: CustomFieldValueFilterBase[];
  onSelectedValuesChange: (values: CustomFieldValueFilterBase[]) => void;
};

export const CustomFieldFilter = ({
  values,
  selectedLogic,
  onLogicChange,
  selectedValues,
  onSelectedValuesChange,
}: CustomFieldFilterProps) => {
  return (
    <div className="flex flex-col items-start">
      <CustomFieldValuesFilterSelect
        className="order-2 w-full"
        values={values}
        selectedValues={selectedValues}
        onSelectedValuesChanged={onSelectedValuesChange}
      />
      <FilterLogicSelect className="order-1" selectedLogic={selectedLogic} onLogicChange={onLogicChange} />
    </div>
  );
};
